import React from 'react';
import CustomerSupportLink from '../CustomerSupportLink';

const GatewayTimeoutAlertBody = (
  <>Please refresh or try again later. Contact {CustomerSupportLink} if the issue persists.</>
);

export default GatewayTimeoutAlertBody;
